module.exports = __webpack_public_path__ + "img/packages/v0.8bdbeb.png";